import React, { useState, useMemo } from 'react';
import { Grid } from '@material-ui/core';
import ReactDOM from 'react-dom';
import { useHistory } from 'react-router-dom';
import BreadCrumbs from '../../../../../Core/Controls/Breadcrumb';
import ReportGijgoGrid from '../../../ReportsScreens/GijgoForReportsScreen';
import formatters from '../../../../../Core/Grid/inputFormatter';
import TCardDashboardModal from '../T-cardModal';
import NoteReminderModal from './noteReminderModal';
import DialogComp from '../../../../../Core/Modal/dialogModal';
import EditIcon from '@material-ui/icons/Edit';
import { SquareButton } from '../../../../../Core/FormInput/AppButton';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'T-Card', path: '/', active: true },
    { name: 'TCards Reminder Notes', path: '/', active: true }
];

const TCardReminderNotesList = () => {
    const history = useHistory();
    const [state, setState] = useState({
        showTCard: false,
        tCardsID: null,
        refreshGrid: Date.now()
    });

    const baseColumns = [
        {
            field: 'action',
            title: `Action`,
            filterable: false,
            sortable: false,
            width: '2%'
        },
        {
            field: 'reg',
            title: `Reg No.`,
            filterable: true,
            sortable: true,
            width: '3%'
        },
        {
            field: 'noteText',
            title: `Note`,
            filterable: true,
            sortable: true,
            width: '10%'
        },
        {
            field: 'cust',
            title: `Customer`,
            filterable: true,
            sortable: true,
            width: '10%'
        },
        {
            field: 'by',
            title: `Booking By`,
            filterable: true,
            sortable: true,
            width: '4%'
        },
        {
            field: 'bd',
            title: `Booking Date`,
            filterable: true,
            sortable: true,
            width: '4%',
            renderer: formatters.YearFormatter
        },
        {
            field: 'noteReminder',
            title: `Reminder Date`,
            filterable: true,
            sortable: true,
            width: '5%',
            renderer: formatters.YearFormatter
        },
        {
            field: 'tCardNoteDate',
            title: `Note Date`,
            filterable: true,
            sortable: true,
            width: '5%',
            renderer: formatters.YearFormatter
        },
        {
            field: 'visibleToCustomer',
            title: `Visible To Customer`,
            filterable: true,
            sortable: true,
            width: '5%',
            renderer: (val) => {
                return val ? 'Yes' : 'No';
            }
        }

        // {
        //     field: 'statusIndicator',
        //     title: `Status`,
        //     filterable: false,
        //     sortable: false,
        //     width: '22%',
        //     renderer: (value, record) => {
        //         const spn = document.createElement('span');
        //         const status = {
        //             cd: record.tCardsIsCollectionDeliver,
        //             waiting: record.tCardsIsCustomerWaiting,
        //             service: record.tCardsIsService,
        //             inspection: record.tCardsIsInspection,
        //             mot: record.tCardsIsMOT,
        //             repair: record.tCardsIsRepair,
        //             ns: record.tCardsIsNightShift,
        //             recall: record.tCardsIsRecallJob,
        //             tacho: record.tCardsIsTacho
        //         };

        //         ReactDOM.render(
        //             <TCardStatusRender status={status} tCardsID={record.tCardsID} />,
        //             spn
        //         );
        //         return spn;
        //     }
        // },
    ];

    const regNoColRenderer = (value, record) => {
        const spn = document.createElement('span');
        if (value) {
            const lnk = (
                <div
                    style={{ fontWeight: 'bold', color: 'blue', cursor: 'pointer' }}
                    onClick={() => {
                        setState((st) => ({
                            ...st,
                            showTCard: true,
                            tCardsID: record.tCardID
                        }));
                    }}
                >
                    {value}
                </div>
            );
            ReactDOM.render(lnk, spn);
        }
        return spn;
    };

    const handleEdit = (val) => {
        setState((st) => ({
            ...st,
            showWarning: true,
            selectedNote: val
        }));
    };

    const editButton = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container alignItems="center" justifyContent="center">
                <SquareButton
                    style={{
                        backgroundColor: '#183B68',
                        borderRadius: '20%',
                        width: '32px',
                        height: '32px',
                        textAlign: 'center',
                        padding: '0px 0px 0px 0px'
                    }}
                    onClick={() => handleEdit(record)}
                >
                    <EditIcon fontSize="small" style={{ color: 'white' }} />
                </SquareButton>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let regNoCol = tempCols.find((element) => element.field === 'reg');
        if (regNoCol) {
            regNoCol.renderer = regNoColRenderer;
        }
        let colAction = tempCols.find((m) => m.field === 'action');
        if (colAction) {
            colAction.renderer = editButton;
        }

        // let wipNoCol = tempCols.find((element) => element.field === 'wipNumber');
        // if (wipNoCol) {
        //     wipNoCol.renderer = wipNumberRenderer;
        // }
        return tempCols;
    }, []);

    const closeReminderModal = (res) => {
        // setState((st) => ({ ...st, showWarning: false, tCardsID: null }));
        let newSt = {};
        newSt.showTCard = false;
        newSt.showWarning = false;
        newSt.tCardsID = null;
        newSt.selectedNote = null;
        if (res) {
            newSt.refreshGrid = new Date();
        }
        setState((st) => ({
            ...st,
            ...newSt
        }));
    };

    return (
        <div className="report-screen-container">
            <BreadCrumbs crumbs={crumbs} />
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <ReportGijgoGrid
                        dataConverter={(res) => ({
                            records: res?.data.dt,
                            total: res?.data?.total
                        })}
                        columns={columns}
                        getUrl={`TCardNotes/TCardNotesReminder_List`}
                        isReload={state.refreshGrid}
                    />
                </Grid>
            </Grid>
            {state.showTCard && <TCardDashboardModal id={state.tCardsID} onClose={closeReminderModal} />}
            {state.showWarning ? (
                <DialogComp title="Edit Note" onClose={() => closeReminderModal(false)} maxWidth="sm">
                    <NoteReminderModal selectedNote={state.selectedNote} onClose={closeReminderModal} />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default TCardReminderNotesList;
